import { api } from "./api";

// Unduh file biner dari API (Bearer via interceptor) dan simpan dengan nama dari Content-Disposition
export const downloadFile = async (url, params, fallbackName = "file.xlsx") => {
  const r = await api.get(url, { params, responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
};
